import {CheckoutOrderHandler} from "../checkoutOrderHandler";
import {CheckoutPayyoPaymentHandler} from "./checkoutPayyoPaymentHandler";
import {__loco} from "../../../utils/localization";
import api from "../../../utils/appApi";
import appApi from "../../../utils/appApi";
import {openWindow, safeRedirect} from "../../../utils/browserUtils";
import {CheckoutPaymentMethodSwitch} from "./checkoutPaymentMethodSwitch";
import Notify from "../../../utils/notify";
import notify from "../../../utils/notify";
import {PAYYO_CARD_INIT_ERROR} from "../../../utils/internalEvents";

export class CheckoutPayyoOrderHandler extends CheckoutOrderHandler
{

    /**
     * Initialize payyo payment handler object
     */
    initializePaymentHandler() {
        this.paymentHandler = new CheckoutPayyoPaymentHandler({
            callbacks: {
                stripeValidationError: error => this.stripeValidationError(error),
                stripeValidationSuccess: data => this.stripeValidationSuccess(data),
                stripeValidationEmpty: data => this.stripeValidationEmpty(data)
            }
        });

        this.paymentHandler.initialize();

        // cache
        // this.renderer = this.validator.renderer;
    }

    /**
     * Attach DOM Listeners
     */
    listen() {
        const self = this;

        /**
         * Desktop submit
         */
        $('#confirm-button, #mobile-checkout-confirm-btn').on('click', function(e){
            e.preventDefault();

            const notify = new Notify();
            if(!$('#checkOutTermsCondition').is(":checked")){
                notify.error(__loco('Please accept terms & conditions'));
                return;
            }

            self.$confirmButton.buttonValidatingOrder();


            self.trigger = e;

            // self.renderer.screenLoading();


            if(CheckoutPaymentMethodSwitch.isPmCreditCard()) {

                /**
                 * Attempt storing card
                 */
                self.paymentHandler.storeCardPromise().then(aliasId => {
                    self.aliasObtained(aliasId);
                }).catch(err => {
                    self.$confirmButton.resetButton();
                    self.paymentHandler.renderErrors(err);

                    $(document).trigger(PAYYO_CARD_INIT_ERROR);
                });

            } else if(CheckoutPaymentMethodSwitch.isAlternativePm()) {

                console.log('twint payment methid');
                /**
                 * Send payment
                 */
                self.validator.validateCartData({paymentAction: true});
            } else {
                notify.error(__loco('Choose a payment method!'));
                self.$confirmButton.resetButton();
            }
        });
    }

    /**
     * Hook into validator's afterRequest hook, receive server response as param,
     *    parse the response, if response is successful and no items were updated, continue to placing an order.
     *
     * @param {Object} response - Response received from server
     * @param {Object} actionParams - Params passed to the validator.validateCartData method, used for easy config transport.
     */
    validatorAfterRequestHook(response, actionParams)
    {
        console.log('validator after reuqest hook fired');



        /**
         * Skip this action if trigger was not "Confirm and pay"
         */
        if(!actionParams.paymentAction) {
            return;
        }

        const items = response.data.data.items;

        let allowContinue = true;

        if(typeof items === "undefined" || !response.data.data.status) {
            allowContinue = false;
        }

        Object.keys(items).forEach((ix) => {
            const item = items[ix];
            if(!item.status) {
                allowContinue = false;
            }
        });

        /**
         * If validation conditions are met - allow placing the order.
         */
        if(allowContinue) {
            this.placeOrder(this.buildRequest());
        } else {
            this.handleCartInvalidData(response);
        }
    }

    /**
     * @inheritDoc
     */
    beforePlaceOrder() {
        this.showProcessingPaymentOverlay();
        this.$confirmButton.buttonProcessingPayment();
    }


    /**
     * Build placeOrder request
     *
     * @return {{bookings: {}}}
     */
    buildRequest() {
        console.log('buildRequest payyo Called');
        let request = super.buildRequest();
        request.payyo_alias_id = this.payyoAliasId;
        request.payment.details.cvv = this.paymentHandler.getCvv();
        request.payment_method = CheckoutPaymentMethodSwitch.getSelectedPaymentMethod();
        return request;
    }


    /**
     * Set alias ID and initialize further steps
     * @param aliasId
     */
    aliasObtained(aliasId) {
        const self = this;

        console.log('ze respons is');
        console.log(aliasId);

        self.payyoAliasId = aliasId;

        // validate cart data, then depending on result it will fire different actions
        // see how validator is initialized and which callbacks are provided
        self.validator.validateCartData({paymentAction: true});
    }

    /**
     * Handle request failure
     *
     * @param error
     */
    handlePlaceOrderError(error) {

        console.log('Error received');
        console.log(error);

        super.handlePlaceOrderError(error);
        this.onError(error);
        if(!!error.message) {
            this.notifier.error(error.message);
        }
    }

    onError(error)
    {
        this.spinnerReset();
        this.removeOverlay();
        this.validator.renderer.renderPlaceOrderErrors(error);
        this.reloadVault();
        this.$confirmButton.resetButton();
    }

    /**
     * Perform placeOrder request
     *
     * @param request
     */
    placeOrder(request) {

        this.beforePlaceOrder();
        api.public.checkout
            .placeOrder(request)
            .then(response => this.handlePlaceOrderResponse(response.data))
            .catch(error => this.handlePlaceOrderError(error.response.data));
    }



    /**
     * Handle place order request
     *
     * After placeOrder was completed, payment was successfulyl done, so we can redirect to checkout.
     *
     * @see CheckoutPayment
     * @param response
     */
    handlePlaceOrderResponse(response) {

        const self = this;

        /**
         * Cache the response from placeOrder action.
         */
        this.orderResponse = response;

        console.log('handle Payyo/place order response');
        console.log(response);

        /**
         * If Order was placed successfully and the response includes paymentIntent and paymentDetails
         *  - Initialize stripe payment.
         */
        if(!!response.data.status /*&& !!response.data.status_details*/) {

            /**
             * If card is 3D secure - open a new window with 3D secure authentication link
             * Begin listening to payment status change, each 3 seconds send a request checking if payment updated.
             */
            if(!!response.data.addons && !!response.data.addons.next_action) {
                // Initialize 3D secure redirect

                if(response.data.addons.next_action === 'redirect' && !!response.data.addons.redirect_url) {
                    // window.location.href = response.data.addons.next_action;
                    openWindow(response.data.addons.redirect_url, '_blank');
                    self.show3DSecureLoading();
                    self.listenForPaymentUpdate();
                }
                // @todo: next_action === capture



            } else {
                /**
                 * 3D Secure is not needed - payment was made.
                 */
                // set button state to - processing payment
                this.paymentResponseCallback(response);
            }

        } else {
            // generic message
            let message = __loco('Something went wrong while processing your order. We did not charge this order, you can try again later.');

            if(!!response.data.message) {
                message = response.data.message;
            }

            this.onError(response);

            this.notifier.error(message);
        }
    }

    getSpinner()
    {
        // return `
        // <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        // `;

        return `<span class="checkout_loader"></span>`;
    }

    /**
     * Spinner success
     */
    spinnerSuccess()
    {
        $('.checkout_loader').addClass('success');
    }

    /**
     * Spinner error
     */
    spinnerFail()
    {
        $('.checkout_loader').addClass('fail');
    }

    /**
     * Reset spinner
     */
    spinnerReset()
    {
        $('.checkout_loader').removeClass('fail success');
    }

    placeOverlay(overlay)
    {
        //#mobile-last-step-wrap
        //@todo: Remove mobile dependency.
        $('.checkout__content .inputs, #mobile-last-step-wrap').append(overlay);
    }


    /**
     * Show processing payment overlay
     */
    showProcessingPaymentOverlay()
    {
        this.removeOverlay();
        this.spinnerReset();
        const $loader = this.getOverlay(__loco('Processing payment...'))
        this.placeOverlay($loader);
    }

    /**
     * Show 3D Secure overlay
     */
    show3DSecureLoading()
    {
        const textContent = `
            <div class="text-line smaller">${__loco('Awaiting 3D authentication.')}</div>
            <div class="text-line">${__loco('Please check your mobile phone to finish the booking.')}</div>
        `;
        this.removeOverlay();
        const $loader = this.getOverlay(textContent);
        this.placeOverlay($loader);

        this.spinnerReset();
    }

    /**
     * SHow payment successful
     */
    showPaymentSuccessFulOverlay()
    {
        this.removeOverlay();
        const $loader = this.getOverlay(__loco('Payment successful!'));
        this.placeOverlay($loader)

        this.spinnerSuccess();
    }

    /**
     * Show payment failed
     */
    showPaymentFailedOverlay()
    {
        this.removeOverlay();
        const $loader = this.getOverlay(__loco('Payment failed.'));
        this.placeOverlay($loader)
        this.spinnerFail();
    }

    /**
     * Remove overlay
     */
    removeOverlay()
    {
        $('.tds_loading').remove();
    }

    /**
     * Get overlay
     * @param text
     * @return {string}
     */
    getOverlay(text)
    {
        this.spinnerReset();
        return `<div class="tds_loading">${this.getSpinner()}<div class="tds_loading__text">${text}</div></div>`
    }

    /**
     * Check payment status each couple of seconds
     */
    listenForPaymentUpdate()
    {
        const self = this;

        if(!!this.orderResponse.data.payment_id) {
            this.paymentStatusVerificationInterval = window.setInterval(function(){
                appApi.public.checkout.getPaymentStatus(self.orderResponse.data.payment_id).then(res => self.parsePaymentStatusRes(res))
            }, 3000);
        }
    }

    /**
     *
     * @param res
     */
    parsePaymentStatusRes(res) {
        console.log('---- payment checking status ----');
        console.log(res);

        if(res.data.data.is_successful) {
            this.showPaymentSuccessFulOverlay();
            this.$confirmButton.buttonPaymentSuccess();


            this.clearCartData();

            setTimeout(function(){
                safeRedirect(res.data.data.redirect_url);
            }, 2000);
        }

        if(res.data.data.is_failed) {
            this.showPaymentFailedOverlay();
            this.$confirmButton.buttonPaymentError();
        }
    }



    /**
     * Reload vault
     */
    reloadVault()
    {
        this.paymentHandler.obtainVault();
    }

    /**
     * Payment response callback override
     * @param result
     */
    paymentResponseCallback(result)
    {
        const self = this;
        console.log('test')

        /**
         * Handle payment error
         */
        if (result.error) {
            // Display error.message in your UI.
            this.notifier.error(result.error.message);

            /**
             * @type {{payment_intent_id: *, client_secret: *, status: *}}
             */
            // const request = {
            //     payment_intent_id: paymentIntent.id,
            //     client_secret: paymentIntent.client_secret,
            //     status: paymentIntent.status,
            //     payment_intent: paymentIntent
            // };

            this.$confirmButton.buttonPaymentError();
            // this.updatePaymentStatus(request);


            setTimeout(function(){
                self.$confirmButton.resetButton();
            }, 3000);

        } else {
            self.$confirmButton.buttonPaymentSuccess();
            self.showPaymentSuccessFulOverlay();
            self.clearCartData();

            //@todo: Uncomment this to redirect to checkout.
            setTimeout(function(){
                if(result.data.status && !!result.redirect_url) {
                    window.location = result.redirect_url;
                }
            }, 3000);
        }
    }
}
